import { Link } from "react-router-dom";
import { useEffect } from "react";
import { OFFER } from "./config/offer.config";
import { trackViewContent } from "./lib/pixel";

/**
 * Home / hero. Un solo objetivo: llevar al estimador. Sin jerga interna,
 * sin "investment bands", sin links de dev. Copy on-brand.
 */
export default function App() {
  useEffect(() => trackViewContent("home"), []);
  return (
    <main className="relative flex min-h-[100dvh] flex-col items-center justify-center overflow-hidden px-6 text-center">
      {/* Hero photo */}
      <img
        src="/img/styles/spa.webp"
        alt="Bathroom transformation"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <span className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />

      <div className="relative z-10 max-w-2xl text-white">
        <p className="font-sans text-xs uppercase tracking-[0.25em] text-white/80">
          A Couple &amp; A Dream · {OFFER.serviceArea.join(" · ")}
        </p>
        <h1 className="mt-5 font-serif text-5xl leading-[1.05] md:text-6xl">
          A master bath that feels like a retreat — designed <em>and</em> built by one couple.
        </h1>
        <p className="mx-auto mt-5 max-w-md text-lg text-white/90">
          Ana Clara &amp; Javier take on only a few bathrooms a month, and walk every one
          themselves. See if yours is a fit.
        </p>
        <Link
          to="/estimator"
          className="mt-8 inline-block rounded-xl bg-bone px-8 py-4 font-sans text-sm font-semibold uppercase tracking-widest text-ink transition hover:bg-clay hover:text-white"
        >
          See if your home makes the cut →
        </Link>
        <p className="mx-auto mt-4 max-w-xs text-xs uppercase tracking-[0.2em] text-white/60">
          Full bathroom renovations from $25,000
        </p>
      </div>
    </main>
  );
}
